// Helper function to validate user input
function validateUserInput(message) {
    if (!message || typeof message !== 'string') {
        return { isValid: false };
    }

    // Trim and limit length
    const trimmedMessage = message.trim().substring(0, 1000);

    if (trimmedMessage.length === 0) {
        return { isValid: false };
    }

    // Check for potentially dangerous patterns
    const dangerousPatterns = [
        /<script[^>]*>/i, // Script tags
        /javascript:/i, // JavaScript protocol
        /on\w+\s*=/i, // Event handlers (onclick, onerror, etc.)
        /<iframe[^>]*>/i, // Iframe tags
        /<object[^>]*>/i, // Object tags
        /<embed[^>]*>/i, // Embed tags
        /<form[^>]*>/i, // Form tags
        /<input[^>]*>/i, // Input tags
        /<meta[^>]*>/i, // Meta tags
        /data:/i, // Data URLs
        /vbscript:/i, // VBScript protocol
    ];

    // Check if message contains dangerous patterns
    const containsDangerousContent = dangerousPatterns.some((pattern) => pattern.test(trimmedMessage));

    return {
        isValid: !containsDangerousContent,
        cleanMessage: trimmedMessage,
    };
}

export default validateUserInput;
